/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { useState, useLayoutEffect, withMemo } from 'fierry/react';


export default withMemo( ({ canDispatch, executeDispatch, ...props }) =>
{
  const [ready, setReady] = useState(true);

  useLayoutEffect(() =>
  {
    if (ready && (canDispatch == null || canDispatch(props)))
    {
      executeDispatch(props);

      setReady(false);
    }
  });

  return null;
});
